import * as React from 'react';
import { Select, Input } from 'antd';
import I18N from 'src/services/I18NService';
import { IMallMedicineSpecification, IMallPharmacyDetail, MedicineUnitLight } from 'src/entity/MallEntity';
// import { EnumMedicineCategory } from 'src/constants/enum';
import { EnumOrderType } from 'src/constants/Order';

const { Option } = Select;

/** 中药服用单位 */
const tcmTakeUnitList: string[] = ['克'];
/** 零售单位/中成药服用单位/批发单位 */
// const fullUnitList: string[] = ['克', '粒', '片', '丸', '袋', '支', '瓶', '盒'];

interface IMedicineSpecificationProps {
  onChange?: (value: Partial<IMallMedicineSpecification> | undefined) => void;
  value?: IMallMedicineSpecification;
  disabled: boolean;
  pharmacy?: IMallPharmacyDetail;
  fullUnitList: MedicineUnitLight[]
}

interface IMedicineSpecificationState {
  specification: string | undefined;
}

class MedicineSpecification extends React.Component<IMedicineSpecificationProps, IMedicineSpecificationState> {
  constructor(props: IMedicineSpecificationProps) {
    super(props);

    let specification = '';
    if (!!props.value && props.value.specification !== undefined && props.value.specification !== null) {
      specification = props.value.specification.toString();
    }
    this.state = {
      specification,
    };
  }

  /**
   * 规格改变时触发
   *
   * @memberof MedicineSpecification
   */
  specificationChange = (e: any) => {
    try {
      let specification = e.target.value as string;
      specification = specification.replace(/。/g, '.');
      specification = specification.replace(/[^0-9.]/gi, '');

      const numArr = specification.split('.');
      if (numArr.length > 2) {
        return;
      }

      if (numArr.length > 1) {
        if (specification.endsWith('.')) {
          specification = `${specification}0`;
          if (isNaN(parseFloat(specification))) {
            return;
          }
          this.setState({
            specification: e.target.value,
          });
          return;
        } else {
          specification = `${numArr[0]}.${numArr[1].substr(0, 4)}`;
        }
      }

      if (numArr[0].trim() !== '' && isNaN(parseFloat(specification))) {
        return;
      }
      this.setState({
        specification,
      });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 失去焦点时触发
   *
   * @memberof MedicineSpecification
   */
  specificationBlur = () => {
    const { value } = this.props;
    const takeUnit = (!!value ? value.take_unit : undefined) || this.getDefaultTakeUnit();
    const retailUnit = (!!value ? value.retail_unit : undefined) || this.getDefaultRetailUnit();
    let wholesaleUnit: string | undefined;
    if (this.props.pharmacy?.order_type === EnumOrderType.药品订单) {
      wholesaleUnit = (!!value ? value.wholesale_unit : undefined) || this.getDefaultRetailUnit();
    }
    this.triggerChange({ specification: Number(this.state.specification), take_unit: takeUnit, retail_unit: retailUnit, wholesale_unit: wholesaleUnit });
  };

  /**
   * 服用单位改变时触发
   *
   * @memberof MedicineSpecification
   */
  takeUnitChange = (takeUnit: string) => {
    this.triggerChange({ take_unit: takeUnit });
  };

  /**
   * 零售单位改变时触发
   *
   * @memberof MedicineSpecification
   */
  retailUnitChange = (retailUnit: string) => {
    this.triggerChange({ retail_unit: retailUnit });
  };

  /**
   * 批发单位改变时触发
   * @memberof MedicineSpecification
   */
  wholesaleUnitChange = (wholesaleUnit: string) => {
    this.triggerChange({ wholesale_unit: wholesaleUnit });
  };

  /**
   * 数据改变时触发
   *
   * @memberof MedicineSpecification
   */
  triggerChange = (changedValue: Partial<IMallMedicineSpecification>) => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  /**
   * 获取默认服用单位
   *
   * @memberof MedicineSpecification
   */
  getDefaultTakeUnit = () => {
    const unitList = this.takeUnitList();
    return unitList.length > 0 ? unitList[0] : undefined;
  };

  /**
   * 服用单位列表
   *
   * @memberof MedicineSpecification
   */
  takeUnitList = () => {
    return tcmTakeUnitList
    // if (this.props.category === EnumMedicineCategory.中药) {
    //   return tcmTakeUnitList;
    // } else if (this.props.category === EnumMedicineCategory.中成药) {
    //   return fullUnitList;
    // }
    // return [];
  };

  /**
   * 服用单位选择项
   *
   * @memberof MedicineSpecification
   */
  takeUnitOptions = (): JSX.Element[] => {
    const result: JSX.Element[] = [];
    const tempUnitList: string[] = this.takeUnitList() || [];
    for (const item of tempUnitList) {
      result.push(
        <Option key={item} value={item}>
          {item}
        </Option>
      );
    }
    return result;
  };

  /**
   * 默认零售单位
   *
   * @memberof MedicineSpecification
   */
  getDefaultRetailUnit = () => {
    return this.props.fullUnitList[0].name;
  };

  /**
   * 零售单位选择项
   *
   * @memberof MedicineSpecification
   */
  retailUnitOptions = () => {
    const result: JSX.Element[] = [];
    const { fullUnitList } = this.props
    for (const item of fullUnitList || []) {
      result.push(
        <Option key={item.id} value={item.name}>
          {item.name}
        </Option>
      );
    }
    return result;
  };

  render() {
    const { value, disabled, pharmacy } = this.props;
    const takeUnit = !!value ? value.take_unit : "克";
    const retailUnit = !!value ? value.retail_unit : undefined;
    const wholesaleUnit = !!value ? value.wholesale_unit : undefined;

    return (
      <span>
        <Input
          min={0.0001}
          value={this.state.specification}
          onChange={this.specificationChange}
          onBlur={this.specificationBlur}
          placeholder={`${I18N.get('common_input')}${I18N.get('common_specification')}`}
          style={{ width: '30%' }}
        />
        {/* {pharmacy?.order_type === EnumOrderType.处方订单 && (
          <span>
            <Select value={takeUnit} 
            disabled={true} style={{ width: '30%' }} 
            onChange={this.takeUnitChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_take_unit')}`}>
              {this.takeUnitOptions()}
            </Select>
            <span style={{ width: '10%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>/</span>
            <Select value={retailUnit} 
            disabled={disabled} style={{ width: '30%' }} 
            onChange={this.retailUnitChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_retail_unit')}`}>
              {this.retailUnitOptions()}
            </Select>
          </span>
        )} */}
        {(
          <span>
            <Select value={takeUnit} disabled={true} style={{ width: '30%' }} onChange={this.takeUnitChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_take_unit')}`}>
              {this.takeUnitOptions()}
            </Select>
            <span style={{ width: '10%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>/</span>
            <Select value={retailUnit} disabled={disabled} style={{ width: '30%' }} onChange={this.retailUnitChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_retail_unit')}`}>
              {this.retailUnitOptions()}
            </Select>
            {/* <Select value={retailUnit} disabled={disabled}
               style={{ width: '30%' }} onChange={this.retailUnitChange} placeholder={`${I18N.get('common_choose')}${I18N.get('med_retail_unit')}`}>
              {this.retailUnitOptions()}
            </Select>
            <span style={{ width: '10%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>/</span>
            <Select value={wholesaleUnit} disabled={disabled} style={{ width: '30%' }} onChange={this.wholesaleUnitChange}
             placeholder={`${I18N.get('common_choose')}${I18N.get('med_wholesale_unit')}`}>
              {this.retailUnitOptions()}
            </Select> */}
          </span>
        )}
      </span>
    );
  }
}

export default MedicineSpecification;


// WEBPACK FOOTER //
// ./src/components/views/Mall/MedicineSpecification.tsx